<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">자동보류 제외 관리</div>
			<div class="tab-btn">
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'status' }" @click="tab = 'status'">제외 현황</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'reason' }" @click="tab = 'reason'">제외 사유</button>
			</div>

			<!-- CY 제외 현황: 누가 어떤 고객을 왜 자동보류에서 뺐는지. 직원 행을 누르면 아래 목록이 그 직원으로 좁혀진다. -->
			<div class="tab-con" v-if="tab === 'status'">
				<div class="txt-c--grey mb-1">
					※ 직원은 본인 담당 고객에게만 사유를 골라 자동보류 제외를 겁니다. 한도를 비워 두면 제한이 없고, 숫자를 넣으면
					그 건수까지만 걸 수 있습니다(0 이면 걸 수 없음). 한도를 줄여도 이미 걸린 제외는 그대로 남습니다.
				</div>
				<div class="sa18-sub">직원별 제외 수</div>
				<div class="table-wrap sa18-staff">
					<table class="table click">
						<colgroup>
							<col />
							<col width="16%" />
							<col width="15%" />
							<col width="15%" />
							<col width="16%" />
							<col width="10%" />
						</colgroup>
						<tr>
							<th>직원</th>
							<th>팀</th>
							<th>담당 고객 중 제외</th>
							<th>직접 제외한 수</th>
							<th>한도</th>
							<th></th>
						</tr>
						<tr
							v-for="m in staffRows"
							:key="'st_' + m.mem_uid"
							v-bind:class="{ 'sa18-on': memFilter === m.mem_uid }"
							@click="pickStaff(m.mem_uid)"
						>
							<td class="txt-l">
								{{ m.mem_name }} {{ m.mem_rank_name || '' }}
								<span v-if="m.is_master" class="sa18-tag">관리자</span>
								<span v-if="m.retired" class="sa18-tag">퇴사</span>
							</td>
							<td>{{ m.team_name || '-' }}</td>
							<td><span v-bind:class="{ 'sa18-num': m.mgr_cnt }">{{ m.mgr_cnt }}</span></td>
							<td><span v-bind:class="{ 'sa18-num': m.set_cnt }">{{ m.set_cnt }}</span></td>
							<td @click.stop>
								<span v-if="m.is_master || m.retired" class="txt-c--grey">-</span>
								<input
									v-else
									class="form-control sa18-quota"
									type="number"
									min="0"
									max="1000"
									placeholder="제한 없음"
									v-model="m.edit"
								/>
							</td>
							<td @click.stop>
								<button
									v-if="!m.is_master && !m.retired"
									type="button"
									class="btn btn-xxsm btn-secondary"
									:disabled="busy || !quotaChanged(m)"
									@click="btnQuotaSave(m)"
								>
									저장
								</button>
							</td>
						</tr>
						<tr v-if="loaded && !staffRows.length">
							<td colspan="6">대상 직원이 없습니다.</td>
						</tr>
					</table>
				</div>

				<div class="sa18-sub">
					제외 고객 <span class="sa18-sub--cnt">{{ filtered.length }}명</span>
				</div>
				<div class="sa18-filter">
					<div class="sa18-seg">
						<button type="button" class="btn" v-bind:class="{ on: by === 'mgr' }" @click="by = 'mgr'">담당자 기준</button>
						<button type="button" class="btn" v-bind:class="{ on: by === 'set' }" @click="by = 'set'">제외한 사람 기준</button>
					</div>
					<button type="button" class="btn sa18-chip" v-bind:class="{ on: !memFilter }" @click="memFilter = null">전 직원</button>
					<button v-if="memFilter" type="button" class="btn sa18-chip on" @click="memFilter = null">
						{{ memName(memFilter) }} ✕
					</button>
					<select v-model="reasonFilter" class="form-control select sm sa18-reason">
						<option value="">사유 전체</option>
						<option v-for="r in reasons" :key="'rf_' + r.reason_key" :value="r.reason_key">{{ r.reason_name }}</option>
					</select>
				</div>
				<div class="table-wrap">
					<table class="table click">
						<colgroup>
							<col width="15%" />
							<col width="12%" />
							<col width="13%" />
							<col width="12%" />
							<col />
							<col width="12%" />
						</colgroup>
						<tr>
							<th>고객명</th>
							<th>담당자</th>
							<th>제외일</th>
							<th>제외사유</th>
							<th>메모</th>
							<th>제외한 사람</th>
						</tr>
						<tr v-for="e in filtered" :key="'ex_' + e.client_uid" @click="openClient(e.client_uid)">
							<td class="txt-l">{{ e.client_name || '-' }}</td>
							<td>{{ e.mgr_name || '-' }}</td>
							<td>{{ e.set_at }}</td>
							<td>
								{{ e.reason_name }}
								<span v-if="e.reason_use === 'N'" class="sa18-tag">사용 안 함</span>
							</td>
							<td class="txt-l">{{ e.memo || '-' }}</td>
							<td>{{ e.set_mem_name || '-' }}</td>
						</tr>
						<tr v-if="loaded && !filtered.length">
							<td colspan="6">{{ list.length ? '조건에 맞는 제외 고객이 없습니다.' : '자동보류에서 제외된 고객이 없습니다.' }}</td>
						</tr>
					</table>
				</div>
			</div>

			<!-- CY 제외 사유: 담당자가 고르는 목록. 지우지 않고 끈다(이미 걸린 제외의 이름이 남아야 한다). -->
			<div class="tab-con" v-else>
				<div class="txt-c--grey mb-1">
					※ 담당자는 이 목록에서 사유를 고르고 메모를 덧붙입니다. 쓰지 않는 사유는 '사용' 을 끄면 새로 고를 수 없고,
					이미 그 사유로 제외된 고객은 그대로 남습니다. '메모 필수' 를 켜면 메모 없이 저장할 수 없습니다.
				</div>
				<div class="table-wrap">
					<table class="table">
						<colgroup>
							<col width="9%" />
							<col width="7%" />
							<col />
							<col width="11%" />
							<col width="9%" />
							<col width="12%" />
							<col width="11%" />
						</colgroup>
						<tr>
							<th>순서</th>
							<th>번호</th>
							<th>사유</th>
							<th>메모 필수</th>
							<th>사용</th>
							<th>제외된 고객</th>
							<th>관리</th>
						</tr>
						<tr v-for="(r, idx) in reasons" :key="'rs_' + r.reason_key">
							<td>
								<button type="button" class="btn sort" v-if="idx != 0" :disabled="busy" @click="btnOrder(idx, -1)">
									<b-icon-arrow-up />
								</button>
								<button type="button" class="btn sort" v-if="idx + 1 != reasons.length" :disabled="busy" @click="btnOrder(idx, 1)">
									<b-icon-arrow-down />
								</button>
							</td>
							<td>{{ idx + 1 }}</td>
							<td><input type="text" class="form-control sm" v-model="r.edit_name" maxlength="30" /></td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :true-value="'Y'" :false-value="'N'" v-model="r.edit_memo" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :true-value="'Y'" :false-value="'N'" v-model="r.edit_use" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>{{ r.used_cnt }}명</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" :disabled="busy || !reasonChanged(r)" @click="btnReasonSave(r)">
									저장
								</button>
							</td>
						</tr>
						<tr v-if="loaded && !reasons.length">
							<td colspan="7">등록된 사유가 없습니다.</td>
						</tr>
						<tr>
							<td colspan="2">추가</td>
							<td><input type="text" class="form-control sm" v-model="addInfo.name" maxlength="30" placeholder="예: 지속 상담중" /></td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :true-value="'Y'" :false-value="'N'" v-model="addInfo.memo" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td colspan="3">
								<button type="button" class="btn btn-xsm btn-primary" :disabled="busy" @click="btnReasonAdd">추가</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// CY(2026-10-07): 자동보류 제외 관리(master 전용, 라우터 meta.master + 서버 isMasterRow).
//   제외 현황: GET /user/admin/hold/exempt/admin  직원별 제외 수 + 제외 고객(고객명·담당자·제외일·사유·메모·제외한 사람)
//   한도:      POST /user/admin/hold/quota        { memUid, quota }  quota=null 이면 제한 없음
//   제외 사유: GET /user/admin/hold/reason, POST /user/admin/hold/reason/save · /order
export default {
	name: 'SystemAdmin18',
	data() {
		return {
			tab: 'status',
			loaded: false,
			busy: false,
			staff: [],
			list: [],
			reasons: [],
			memFilter: null,
			by: 'mgr',
			reasonFilter: '',
			addInfo: { name: '', memo: 'N' },
		};
	},
	created() {
		this.load();
	},
	computed: {
		// 제외가 많은 직원부터. 같으면 이름순(서버 순서).
		staffRows() {
			return this.staff
				.map((m, i) => ({ m, i }))
				.sort((a, b) => b.m.mgr_cnt + b.m.set_cnt - (a.m.mgr_cnt + a.m.set_cnt) || a.i - b.i)
				.map(x => x.m);
		},
		filtered() {
			return this.list.filter(e => {
				if (this.reasonFilter && e.reason !== this.reasonFilter) return false;
				if (!this.memFilter) return true;
				const who = this.by === 'mgr' ? e.mgr_mem_uid : e.set_mem_uid;
				return Number(who) === Number(this.memFilter);
			});
		},
	},
	methods: {
		async load() {
			const [st, rs] = await Promise.all([
				this.$apiGET('/admin/api/user/admin/hold/exempt/admin'),
				this.$apiGET('/admin/api/user/admin/hold/reason'),
			]);
			if (st && Array.isArray(st.staff)) this.setStatus(st);
			if (Array.isArray(rs)) this.setReasons(rs);
			this.loaded = true;
		},
		// 현황은 직원별 수와 고객 목록을 같은 응답으로 함께 바꾼다(목록만 바꾸면 위아래 숫자가 어긋난다).
		// 저장하지 않은 한도 입력은 남긴다.
		setStatus(st) {
			const typed = new Map(this.staff.filter(m => this.quotaChanged(m)).map(m => [m.mem_uid, m.edit]));
			this.staff = st.staff.map(m => ({
				...m,
				edit: typed.has(m.mem_uid) ? typed.get(m.mem_uid) : m.quota == null ? '' : String(m.quota),
			}));
			this.list = st.list || [];
		},
		// 한 줄을 저장·추가하거나 순서를 바꾼 뒤 목록을 다시 받아도, 다른 줄에서 고치던 저장 전 내용은 남긴다
		// (codex 리뷰 지적: 줄마다 고친 뒤 차례로 저장하면 앞에서 고친 줄이 말없이 되돌아갔다). savedKey 줄만 서버 값으로.
		setReasons(rs, savedKey = null) {
			const typed = new Map(this.reasons.filter(r => r.reason_key !== savedKey && this.reasonChanged(r)).map(r => [r.reason_key, r]));
			this.reasons = rs.map(r => {
				const t = typed.get(r.reason_key);
				return {
					...r,
					edit_name: t ? t.edit_name : r.reason_name,
					edit_memo: t ? t.edit_memo : r.memo_required,
					edit_use: t ? t.edit_use : r.use_flag,
				};
			});
		},
		async reloadReasons(savedKey = null) {
			const rs = await this.$apiGET('/admin/api/user/admin/hold/reason');
			if (Array.isArray(rs)) this.setReasons(rs, savedKey);
		},
		memName(uid) {
			const m = this.staff.find(x => x.mem_uid === Number(uid));
			return m ? m.mem_name : '';
		},
		pickStaff(uid) {
			this.memFilter = this.memFilter === uid ? null : uid;
		},
		openClient(cid) {
			const w = window.screen.availWidth;
			const h = window.screen.availHeight;
			window.open('/UserDetail/' + cid, '', 'width=' + w + ', height=' + h + ', resizable=no, status=no');
		},
		// ── 한도 ──
		quotaValue(m) {
			const v = m.edit === null || m.edit === undefined ? '' : String(m.edit).trim();
			return v === '' ? null : Number(v);
		},
		quotaChanged(m) {
			return this.quotaValue(m) !== m.quota;
		},
		async btnQuotaSave(m) {
			const quota = this.quotaValue(m);
			if (quota !== null && (!Number.isInteger(quota) || quota < 0 || quota > 1000)) {
				alert('한도는 비우거나(제한 없음) 0~1000 사이 정수로 입력하세요.');
				return;
			}
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/hold/quota', { memUid: m.mem_uid, quota });
				if (!re || !re.ok) return;
				m.quota = quota;
				m.edit = quota == null ? '' : String(quota);
			} finally {
				this.busy = false;
			}
		},
		// ── 사유 ──
		reasonChanged(r) {
			return (r.edit_name || '').trim() !== r.reason_name || r.edit_memo !== r.memo_required || r.edit_use !== r.use_flag;
		},
		async btnReasonSave(r) {
			const name = (r.edit_name || '').trim();
			if (!name) {
				alert('사유 이름을 입력하세요.');
				return;
			}
			if (r.edit_use === 'N' && r.use_flag === 'Y' && r.used_cnt > 0) {
				if (!confirm(`'${r.reason_name}' 사유를 끕니다. 이미 이 사유로 제외된 고객 ${r.used_cnt}명은 그대로 남고, 새로 고를 수만 없습니다.`)) return;
			}
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/hold/reason/save', {
					key: r.reason_key,
					name,
					memoRequired: r.edit_memo,
					useFlag: r.edit_use,
				});
				if (!re || !re.ok) return;
				await this.reloadReasons(r.reason_key);
				// 이름이 바뀌었으면 현황의 사유 이름도 새로 받는다(직원별 수도 같은 응답으로).
				const st = await this.$apiGET('/admin/api/user/admin/hold/exempt/admin');
				if (st && Array.isArray(st.staff)) this.setStatus(st);
			} finally {
				this.busy = false;
			}
		},
		async btnReasonAdd() {
			const name = (this.addInfo.name || '').trim();
			if (!name) {
				alert('사유 이름을 입력하세요.');
				return;
			}
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/hold/reason/save', { name, memoRequired: this.addInfo.memo, useFlag: 'Y' });
				if (!re || !re.ok) return;
				this.addInfo = { name: '', memo: 'N' };
				await this.reloadReasons();
			} finally {
				this.busy = false;
			}
		},
		async btnOrder(idx, dir) {
			const keys = this.reasons.map(r => r.reason_key);
			const j = idx + dir;
			if (j < 0 || j >= keys.length) return;
			[keys[idx], keys[j]] = [keys[j], keys[idx]];
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/hold/reason/order', { keys });
				// 다른 관리자가 그 사이 사유를 더했으면 서버가 409 로 거절한다. 목록을 새로 받아 다시 정렬하게 한다.
				await this.reloadReasons();
				if (!re || !re.ok) return;
			} finally {
				this.busy = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
// 값의 출처는 DESIGN.md 하나뿐이다. 색·간격을 숫자로 새로 만들지 않는다.
@import '@/assets/css/design-tokens.scss';

.sa18-sub {
	margin: 16px 0 8px;
	font-size: 14px;
	font-weight: 700;
	color: $dt-color-ink;
	&--cnt {
		margin-left: 4px;
		font-weight: 400;
		color: $dt-color-ink-faint;
	}
}
.sa18-staff {
	max-height: 420px;
	overflow-y: auto;
}
// 표 칸 바로 안의 span 은 bootstrap 셀 규칙(0,1,1)에 8px 패딩·흰 배경을 입는다(메모: bootstrap 표 인라인 오염).
// 표 클래스를 앞에 붙여(0,2,0) 이긴다.
.table .sa18-num {
	padding: 0;
	background: transparent;
	color: $dt-color-primary-ink;
	font-weight: 600;
}
.table .sa18-tag {
	display: inline-block;
	margin-left: 4px;
	padding: 0 5px;
	font-size: 11px;
	line-height: 16px;
	color: $dt-color-ink-muted;
	background: transparent;
	border: 1px solid $dt-color-line-strong;
	border-radius: $dt-rounded-chip;
	white-space: nowrap;
}
.table tr.sa18-on td {
	background: $dt-color-surface-sunken;
}
.sa18-quota {
	width: 100px;
	height: $dt-spacing-control-height;
	font-size: 13px;
	display: inline-block;
}
.sa18-filter {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 6px;
	margin-bottom: 8px;
	.sa18-seg {
		display: inline-flex;
		margin-right: 6px;
		.btn {
			height: 26px;
			padding: 0 10px;
			font-size: 12px;
			border: 1px solid $dt-color-line-strong;
			border-radius: 0;
			background: $dt-color-surface;
			color: $dt-color-ink-muted;
			& + .btn {
				margin-left: -1px;
			}
			&.on {
				background: $dt-color-primary-ink;
				border-color: $dt-color-primary-ink;
				color: #fff;
			}
		}
	}
	// bootstrap .btn 과 특이도가 같으면 로드 순서에 따라 배경·테두리가 덮인다 → 부모를 함께 쓴다.
	.sa18-chip {
		height: 24px;
		padding: 0 10px;
		font-size: 12px;
		line-height: 1;
		border: 1px solid $dt-color-line-strong;
		border-radius: $dt-rounded-full;
		background: $dt-color-canvas;
		color: $dt-color-ink-muted;
		white-space: nowrap;
		&.on {
			background: $dt-color-primary-ink;
			border-color: $dt-color-primary-ink;
			color: #fff;
		}
	}
	// 공용 .form-control.sm 크기는 검색줄(.search-top) 안에서만 잡힌다. 여기서는 칩 줄 높이에 직접 맞춘다.
	.sa18-reason {
		width: 140px;
		height: $dt-spacing-control-height;
		margin-left: 6px;
		padding-top: 0;
		padding-bottom: 0;
		font-size: 13px;
	}
}
</style>
